import React from 'react';
import { Link } from 'react-router-dom';

const userName = localStorage.getItem('AdminName');

const handleLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('AdminName');
  localStorage.removeItem('adminID');
  window.location.href = '/cl'; // or your login route
};
const SideBar = () => {
  return (
    <div className="App">
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark bg-navy elevation-4">
        {/* Brand Logo */}
        <a href="/dashboard" style={{ textDecoration: 'none' }} className="brand-link">
          {/* <img src="dist/img/AdminLTELogo.png" alt="AdminLTE Logo" className="brand-image img-circle elevation-3" style={{opacity: '.8'}} /> */}
          <span className="brand-text font-weight-light">TPS ADMIN</span>
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              {/* <img src="dist/img/user2-160x160.jpg" className="img-circle elevation-2" alt="User Image" /> */}
            </div>
            <div style={{ textDecoration: 'none' }} className="info">
              Wel-come : {userName || 'Guest'}
            </div>
          </div>

          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
              <li className="nav-item">


                <Link to="/admin/dashboard" className="nav-link">
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>
                    Dashboard
                    <i className="right fas" />
                  </p>
                </Link>

              </li>

              <li className="nav-item">
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-copy" />
                  <p>
                    Masters
                    <i className="fas fa-angle-right right" />

                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="/admin/register-host" className="nav-link">

                      <p>Register Host</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/verify-author" className="nav-link">

                      <p>Validate Author</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/verify-reviewer" className="nav-link">


                      <p>Validate Reviewer</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/verify-hosts" className="nav-link">
                      <p>Validate Host</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/submission-assignment" className="nav-link">
                      <p>Assign Submission</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/platforms" className="nav-link">


                      <p>Platforms Manager</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/review-replies-list" className="nav-link">


                      <p>Review Replies</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/reviewer-decision-matrix" className="nav-link">

                      <p>Decision Matrix</p>
                    </Link>
                  </li>

                </ul>
              </li>
              <li className="nav-item">
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-chart-pie" />
                  <p>
                    Reports
                    <i className="right fas fa-angle-right" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="/admin/authors-list" className="nav-link">


                      <p>Author Registered</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/reviewer-list" className="nav-link">


                      <p>Reviewer Registered</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/admin/submission-list" className="nav-link">
                      <p>Submissions</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <button onClick={handleLogout} className="nav-link btn btn-danger text-left">
                  <i className="nav-icon fas fa-sign-out-alt" />
                  <p>Logout</p>
                </button>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>

    </div>
  );
};

export default SideBar;